import * as React from 'react'
import Spinner from './loading.gif';
import  "./styles.scss"

export function Loading() {
    return (
        <div className="loading" >
            <img src={Spinner} />
        </div>
    )
}
